import { render, staticRenderFns } from "./RegisterMuat.vue?vue&type=template&id=6d316893&scoped=true&"
import script from "./RegisterMuat.vue?vue&type=script&lang=js&"
export * from "./RegisterMuat.vue?vue&type=script&lang=js&"
import style0 from "./RegisterMuat.vue?vue&type=style&index=0&id=6d316893&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d316893",
  null
  
)

export default component.exports